export default __webpack_public_path__ + "static/bpifrance-5966516b0d018173562f4697900c1ab6.png";